module.exports = __webpack_public_path__ + "img/deak-article-pic.dcc8dca8.png";